import { create } from 'zustand';

interface LearnerProfileStore {
  isActiveUser: boolean;
  setIsActiveUser: (isActiveUser: boolean) => void;
  accountSettingsModalIsOpen: boolean;
  setAccountSettingsModalIsOpen: (accountSettingsModalIsOpen: boolean) => void;
  userDetailsModalIsOpen: boolean;
  setUserDetailsModalIsOpen: (userDetailsModalIsOpen: boolean) => void;
  scrollToSection: string | null;
  setScrollToSection: (section: string | null) => void;
}

export const useLearnerProfileStore = create<LearnerProfileStore>((set) => ({
  isActiveUser: false,
  setIsActiveUser: (isActiveUser) => set({ isActiveUser }),
  accountSettingsModalIsOpen: false,
  setAccountSettingsModalIsOpen: (accountSettingsModalIsOpen) =>
    set({ accountSettingsModalIsOpen }),
  userDetailsModalIsOpen: false,
  setUserDetailsModalIsOpen: (userDetailsModalIsOpen) => set({ userDetailsModalIsOpen }),
  scrollToSection: null,
  setScrollToSection: (scrollToSection) => set({ scrollToSection }),
}));
